import {
	ApplyForm1,
	ApplyForm2,
	ApplyForm3,
	RegistCompanyForm,
	SignupForm,
} from "@src/model/signupAndApplyModel";
import { atom } from "recoil";
import { v1 } from "uuid";

const registCompanyFormState = atom<RegistCompanyForm>({
	key: `registCompanyFormState${v1()}`,
	default: {
		companyName: "",
		companySize: "",
		industry: "",
	},
});

const applyForm1State = atom<ApplyForm1>({
	key: `applyForm1State${v1()}`,
	default: {
		matchPurpose: "",
		job: "",
		requestedTask: "",
		requestedTaskUrl: "",
		etcJob: "",
	},
});

const applyForm2State = atom<ApplyForm2>({
	key: `applyForm2State${v1()}`,
	default: {
		desiredStartDate: "",
		expectedWorkload: "",
		estimatedBusinessDuration: "",
		isRemoteWork: "",
	},
});

const applyForm3State = atom<ApplyForm3>({
	key: `applyForm3State${v1()}`,
	default: {
		matchBudget: "",
		govSubsidy: false,
		promotionCode: "",
		matchMonthBudget: "",
	},
});

const signupFormState = atom<SignupForm>({
	key: `signupFormState${v1()}`,
	default: {
		name: "",
		position: "",
		email: "",
		password: "",
		phone: "",
		knownPath: "",
		knownPathDetail: "",
		marketingConsent: false,
	},
});

export {
	applyForm1State,
	applyForm2State,
	applyForm3State,
	registCompanyFormState,
	signupFormState,
};
